import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import TransportMeansPage from './transport-means'

const transportMeanRoutes: Route[] = [
  {
    path: Paths.SETTING_TRANSPORT_MEANS,
    element: <TransportMeansPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default transportMeanRoutes
